<template>
	<div class="main">
		<div class="modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<span v-if="feeType == 'N'" class="modal-title">新增減免費用設定</span>
						<span v-if="feeType == 'G'" class="modal-title">新增軍公教遺族補助費設定</span>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePopup">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div v-if="feeType == 'N'" class="modal-body">
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="smtr" class="col-sm-4 col-xs-2 column-required">學期</label>
								<div class="col-sm-8 col-xs-10">
									<select id="smtr" name="smtr" v-validate="'required'" v-model="NForm.smtr" class="form-control">
										<option v-for="(smrt, index) in $parent.selectSmtr()" :key="index" :value="smrt.value">{{smrt.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="reliefType" class="col-sm-4 col-xs-2 column-required">申請類別</label>
								<div class="col-sm-8 col-xs-10">
									<select id="reliefType" name="reliefType" v-validate="'required'" v-model="NForm.reliefType" class="form-control">
										<option value="">請選擇</option>
										<option v-for="(item,key) in reliefTypeList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="kindType" class="col-sm-4 col-xs-2 column-required">部 別</label>
								<div class="col-sm-8 col-xs-10">
									<select id="kindType" name="kindType" v-validate="'required'" v-model="NForm.kindType" class="form-control">
										<option value="">請選擇</option>
										<option v-for="(item,key) in kindList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="row form-group">
								<div class="col-md-4 form-group">
									<label for="deptType" class="col-sm-4 col-xs-2 column-required">科系別</label>
									<div class="col-sm-8 col-xs-10">
										<select id="deptType" name="deptType" v-validate="'required'" v-model="NForm.deptType" class="form-control">
										<option value="">請選擇</option>
										<option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4 form-group">
									<label for="countType" class="col-sm-4 col-xs-2 column-required">計算方式</label>
									<div class="col-sm-8 col-xs-10">
										<select id="countType" name="countType" v-validate="'required'" v-model="NForm.countType" class="form-control" @change="changeCountType()">
											<option value="">請選擇</option>
											<option v-for="(item,key) in feeCountList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4 form-group">
									<label for="discountPercent" class="col-sm-4 col-xs-2">折扣百分比(%)</label>
									<div class="col-sm-8 col-xs-10">
										<input id="discountPercent" name="discountPercent" v-model="NForm.discountPercent" v-validate="'integer|max_value:100|min_value:1'" type="number" min="1" max="100" class="form-control" :disabled="!(NForm.countType == 'D' || NForm.countType == 'T')"/>
                    <span class="text-danger" v-show="errors.has('discountPercent')">請輸入 1 ~ 100 之間的整數值</span>
									</div>
								</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="tuitionFee" class="col-sm-4 col-xs-2">學 費</label>
								<div class="col-sm-8 col-xs-10">
									<input id="tuitionFee" name="tuitionFee" v-model="NForm.tuitionFee" v-validate="'integer|min_value:0'" type="number" class="form-control" :disabled="!(NForm.countType == 'S')"/>
                  <span class="text-danger" v-show="errors.has('tuitionFee')">請輸入正整數</span>
                </div>
							</div>
							<div class="col-md-4 form-group">
								<label for="miscellaneousFee" class="col-sm-4 col-xs-2">雜 費</label>
								<div class="col-sm-8 col-xs-10">
									<input id="miscellaneousFee" name="miscellaneousFee" v-model="NForm.miscellaneousFee" v-validate="'integer|min_value:0'" type="number" class="form-control" :disabled="!(NForm.countType == 'S')"/>
                  <span class="text-danger" v-show="errors.has('miscellaneousFee')">請輸入正整數</span>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="insurancePremium" class="col-sm-4 col-xs-2">保險費</label>
								<div class="col-sm-8 col-xs-10">
									<input id="insurancePremium" name="insurancePremium" v-model="NForm.insurancePremium" v-validate="'integer|min_value:0'" type="number" class="form-control" :disabled="!(NForm.countType == 'S' || NForm.countType == 'D')"/>
                  <span class="text-danger" v-show="errors.has('insurancePremium')">請輸入正整數</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="feeType == 'G'" class="modal-body">
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="smtr" class="col-sm-4 col-xs-2 column-required">學期</label>
								<div class="col-sm-8 col-xs-10">
									<select id="smtr" name="smtr" v-validate="'required'" v-model="GForm.smtr" class="form-control">
										<option v-for="(smrt, index) in $parent.selectSmtr()" :key="index" :value="smrt.value">{{smrt.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="reliefType" class="col-sm-4 col-xs-2 column-required">申請類別</label>
								<div class="col-sm-8 col-xs-10">
									<select id="reliefType" name="reliefType" v-validate="'required'" v-model="GForm.reliefType" class="form-control">
										<option value="">請選擇</option>
										<option v-for="(item,key) in reliefTypeList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="bookFee" class="col-sm-4 col-xs-2">書籍費</label>
								<div class="col-sm-8 col-xs-10">
									<input id="bookFee" name="bookFee" v-model="GForm.bookFee" type="number" class="form-control" />
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="uniformFee" class="col-sm-4 col-xs-2">制服費</label>
								<div class="col-sm-8 col-xs-10">
									<input id="uniformFee" name="uniformFee" v-model="GForm.uniformFee" type="number" class="form-control" />
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="livingFee" class="col-sm-4 col-xs-2">生活費</label>
								<div class="col-sm-8 col-xs-10">
									<input id="livingFee" name="livingFee" v-model="GForm.livingFee" type="number" class="form-control" />
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="handleSave">{{this.id == "" ? '新增' : '儲存'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['feeType', 'id'],
	data(){
		return {
			NForm: {
				smtr: "",
				feeType: "N",
				reliefType: "",
				kindType: "",
				deptType: "",
				countType: "",
				discountPercent: "",
				tuitionFee: "",
				miscellaneousFee: "",
				insurancePremium: ""
			},
			GForm: {
				smtr: "",
				feeType: "G",
				reliefType: "",
				bookFee: "",
				uniformFee: "",
        livingFee: ""
			},
			feeCountList: [],
			kindList: [],
			reliefTypeList: [],
			deptList: [],
		}
	},
	mounted(){
		this.pageInit();
	},
	methods:{
		pageInit(){
			const api = "/api/reliefFee/editInit";
			this.$axios.get(api).then(res => {
				this.feeCountList = res.data.data.selectList.feeCount
				this.kindList = res.data.data.selectList.kind
				this.reliefTypeList = res.data.data.selectList.reliefType
				this.deptList = res.data.data.selectList.dept
				// 修改讀取單筆資料
				if(this.id != "") {
					const api = `/api/reliefFee/${this.id}`;
					this.$axios.get(api).then(resp => {
						if (resp.data.status === "success") {
							if(this.feeType == 'N') {
								this.NForm = resp.data.data
							} else if (this.feeType == 'G'){
								this.GForm = resp.data.data
							}
						} else {
							bootbox.alert(resp.data.msg);
						}
					})
				} else {
					this.NForm.smtr = this.$parent.qryParam.smtr;
					this.GForm.smtr = this.$parent.qryParam.smtr;
				}

				// 軍公教費用設定只留軍公教選項
				if(this.feeType == 'G') {
					this.reliefTypeList = this.reliefTypeList.filter(item =>
						item.commCode == 'A2' ||
						item.commCode == 'A3' ||
						item.commCode == 'A4');
				}
			});
		},
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if(this.id == "") {
						// 新增
						const api = "/api/reliefFee";
						const form = this.feeType == "N" ? this.NForm : this.GForm;
						this.$axios.post(api, form).then(resp => {
							if (resp.data.status === "success") {
								bootbox.alert("新增成功");
								this.closePopup();
							} else {
								bootbox.alert(resp.data.msg);
							}
						});
					} else {
						// 修改
						const api = `/api/reliefFee/${this.id}`;
						const form = this.feeType == "N" ? this.NForm : this.GForm;
						this.$axios.post(api, form).then(resp => {
							if (resp.data.status === "success") {
								bootbox.alert("儲存成功");
								this.closePopup();
							} else {
								bootbox.alert(resp.data.msg);
							}
						});
					}
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});
		},
    changeCountType() {
      this.NForm.tuitionFee = '';
      this.NForm.miscellaneousFee = '';
      this.NForm.insurancePremium = '';
      this.NForm.discountPercent = '';
    },
		closePopup() {
			this.$parent.showEditPopup(false);
		}
	}
}
</script>
<style scoped>
@media (min-width: 768px){
	.modal-dialog {
		width: 720px;
		margin: 30px auto;
	}
}

@media (min-width: 992px){
	.modal-dialog {
		width: 880px;
		margin: 30px auto;
	}
}

@media (min-width: 1200px){
	.modal-dialog {
		width: 1120px;
		margin: 30px auto;
	}
}
</style>
